module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal modal--lesson"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-content"
  }, [(_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), (_vm.viewed) ? _c('icon', {
    staticClass: "status",
    attrs: {
      "name": "check"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.links.length) ? _c('div', {
    staticClass: "links"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('university.lesson.related')))]), _vm._v(" "), _c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.learn(link)
        }
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.action) ? _c('action', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "orange"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.performAction.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('university.lesson.try')))]) : _vm._e(), _vm._v(" "), _c('action', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.done')))]), _vm._v(" "), (_vm.previous && _vm.next) ? _c('action', {
    attrs: {
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.previousStep.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.back')))]) : _vm._e(), _vm._v(" "), (_vm.next) ? _c('action', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextStep.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('label.moment.next')))]) : _vm._e()], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42538752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Lesson.vue
// module id = 475
// module chunks = 225